import React, { PureComponent } from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class TableHeader extends PureComponent {
    constructor(props) { super(props); }

    render() {
        const { limitesCliente } = this.props;

        return (
            <thead>
                <tr className="tr-bold tr-bold-black">
                    <th className="principal-td" colSpan="2">
                        <label className="label-secondary"><span className="fa fa-money fa-lg"></span> Límite global total:</label>
                    </th>
                    <th className="td-algn td-algn-right">
                        <label className="label-secondary">$ {GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimitePorCuit)}</label>
                    </th>
                    <th colSpan="3">
                        <label></label>
                    </th>
                </tr>
            </thead>
        );
    }
}

export default TableHeader;